import React from 'react'
import { SignInCTA, SmallNotificationContainer } from './styled'

export interface SmallNotificationBannerProps {
  message: string
  ctaText: string
  'data-test'?: string
  className?: string
  onSignInClick: () => void
  SIGN_IN_BUTTON: string
}

export const SmallNotificationBanner = ({
  message,
  ctaText,
  'data-test': dataTest,
  SIGN_IN_BUTTON,
  onSignInClick,
  ...rest
}: SmallNotificationBannerProps): JSX.Element => {
  return (
    <SmallNotificationContainer {...rest} data-test={dataTest || undefined}>
      <span>{message}</span>
      <SignInCTA onClick={onSignInClick} data-test={SIGN_IN_BUTTON}>
        {ctaText}
      </SignInCTA>
    </SmallNotificationContainer>
  )
}

SmallNotificationBanner.displayName = 'SmallNotificationBanner'

export default SmallNotificationBanner
